import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(
  theme => ({
    icon: {
      fill: theme.colors.searchButton,
    },
    iconFilled: {
      fill: theme.colors.editIconColor,
    },
  }),
  { name: 'AddNote' },
)

export interface AddNoteProps extends SvgIconProps {
  readonly filled?: boolean
}

const AddNote = forwardRef<SVGSVGElement, AddNoteProps>(function AddNote(
  { filled, ...rest },
  ref,
) {
  const classes = useStyles()

  const iconPath = filled ? (
    <path
      className={classes.iconFilled}
      d="M15,0 C15.5522847,0 16,0.44771525 16,1 L16,9 L10.2819426,9 C9.83618323,9 9.67454011,9.04641281 9.51157715,9.13356635 C9.34861419,9.2207199 9.2207199,9.34861419 9.13356635,9.51157715 C9.04641281,9.67454011 9,9.83618323 9,10.2819426 L9,10.2819426 L9,15.998 L1,16 C0.44771525,16 0,15.5522847 0,15 L0,1 C0,0.44771525 0.44771525,0 1,0 L15,0 Z M14.559087,11.8199525 L14.1437336,12.2352248 C13.3861097,12.9940769 12.338486,14.0498322 11.0008626,15.4024907 L11,12 L11.0067277,11.8833789 C11.0644928,11.3860402 11.4871642,11 12,11 L12,11 L15.3885534,11.0001716 C15.21087,11.1722744 14.9343812,11.4455347 14.559087,11.8199525 Z"
      transform="translate(4, 4)"
    />
  ) : (
    <path
      className={classes.icon}
      d="M15,0 C15.5522847,0 16,0.44771525 16,1 L16,10 C16,10.320073 15.8496256,10.6050242 15.6156707,10.7880597 L10.7798643,15.6260055 C10.605475,15.8429778 10.3424022,15.98564 10.0456622,15.998976 L10.0421365,16 L1,16 C0.44771525,16 0,15.5522847 0,15 L0,1 C0,0.44771525 0.44771525,0 1,0 L15,0 Z M13,2 L3,2 C2.48716416,2 2.06449284,2.38604019 2.00672773,2.88337887 L2,3 L2,13 C2,13.5128358 2.38604019,13.9355072 2.88337887,13.9932723 L3,14 L9,14 L9,10.2819426 C9,9.83618323 9.04641281,9.67454011 9.13356635,9.51157715 C9.2207199,9.34861419 9.34861419,9.2207199 9.51157715,9.13356635 C9.67454011,9.04641281 9.83618323,9 10.2819426,9 L14,9 L14,3 C14,2.44771525 13.5522847,2 13,2 Z M12.5822555,10.5 L11.5,10.5 C10.9477153,10.5 10.5,10.9477153 10.5,11.5 L10.5,11.5 L10.5,12.6488702 C10.5,12.7763849 10.5522529,12.8983294 10.6445799,12.9862822 C10.8309274,13.1638009 11.1258993,13.1566437 11.303418,12.9702962 L11.303418,12.9702962 L12.0986487,12.135515 C12.1041067,12.1297856 12.1096324,12.1241212 12.1152249,12.1185229 L12.1152249,12.1185229 L12.9194499,11.3134603 C13.0087256,11.2240916 13.0588723,11.1029375 13.0588723,10.9766168 C13.0588723,10.7133886 12.8454837,10.5 12.5822555,10.5 L12.5822555,10.5 Z"
      transform="translate(4, 4)"
    />
  )

  return (
    <SvgIcon ref={ref} {...rest}>
      {iconPath}
    </SvgIcon>
  )
})

export default AddNote
